import { Injectable, inject } from '@angular/core';

import { NativeAppService, WINDOW } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class MobileHelper {
    private nativeAppService = inject(NativeAppService);

    readonly isAndroidNative: boolean;
    readonly isSafariIos: boolean;
    readonly isAndroidWrapper: boolean;
    private readonly _window = inject(WINDOW);

    constructor() {
        this.isAndroidNative = this.isAndroidNativeInternal();
        this.isSafariIos = this.isSafariIosInternal();
        this.isAndroidWrapper = this.isAndroidNative && this.nativeAppService.isNative;
    }

    private isAndroidNativeInternal(): boolean {
        const ua = this._window.navigator.userAgent;
        if (!ua) {
            return false;
        }

        return this.valueContainsAll(ua, ['Mozilla/5.0', 'Android ', 'AppleWebKit']) && this.valueContainsAny(ua, ['Version', 'Samsung']);
    }

    private isSafariIosInternal(): boolean {
        const ua = this._window.navigator.userAgent;
        if (!ua) {
            return false;
        }

        return this.valueContainsAll(ua, ['(iPhone)', 'Safari', 'iPhone']) && !/CriOS/g.test(ua);
    }

    private valueContainsAll(text: string, valuesToCheck: string[]): boolean {
        return valuesToCheck.every((v) => text.includes(v));
    }

    private valueContainsAny(text: string, valuesToCheck: string[]): boolean {
        return valuesToCheck.some((v) => text.includes(v));
    }
}
